/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice\src\Theme\Component\PricingSpan.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_frontoffice
 * Created Date: Tuesday September 3rd 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 3rd 2024 3:07:18 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */


import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const SpanStyled = styled.span.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
width: fit-content;
padding: 0.5rem 1rem;
text-wrap: nowrap;
border-radius: 1rem;
color: white;
background-color: ${(props: any) => getThemeColor(props.bgColor)};
box-shadow: 0px 5px 15px ${(props: any) => getThemeColor(props.bgColor)};
`

export default SpanStyled;
